export default __webpack_public_path__ + "static/media/plodelogo.7784daec.svg";